import { StepIndicator } from "./components/steps/components/stepIndicator";
import { Steps } from "./components/steps/steps";
import { Base } from "./navigation.base";

export const Navigation = Object.assign(Base, {
    Steps,
    StepIndicator
});
